/* eslint-disable no-case-declarations */
/* eslint-disable default-case */
import React from 'react';
import moment from 'moment';

import CustomToolbar from '../../../common/CustomToolbar/CustomToolbar';
import globals from '../../../../globals/communityGlobals';
import { secondsToHms } from '../../../../utils/dates';
import _ from '../../../../utils/lodash';
import { logTypeEnums } from '../../../../settings/other';

const tableSettings = options => {
  return {
    name: '',
    columns: [
      {
        name: 'id',
        options: {
          display: 'excluded',
        },
      },
      {
        name: 'status',
        label: 'Allocation status',
        options: {
          sort: false,
          customBodyRender: value => (value >= 0 ? _.find(logTypeEnums, x => x.id === value).name : '-'),
        },
      },
      {
        name: 'durationInSeconds',
        label: 'Duration',
        options: {
          sort: false,
          setCellProps: () => ({ style: { width: '150px' } }),
          customBodyRender: value => (value > 0 ? secondsToHms(value) : '-'),
        },
      },
      {
        name: 'dayNightMode',
        label: 'Period',
        options: {
          sort: false,
          setCellProps: () => ({ style: { width: '100px' } }),
        },
      },
      {
        name: 'createdDate',
        label: 'Created Date',
        options: {
          sort: false,
          setCellProps: () => ({ style: { width: '170px' } }),
          customBodyRender: value => (value ? moment(value).format(globals.dateFormats.shortWithTime) : '-'),
        },
      },
      {
        name: 'selectedDate',
        label: 'Selected Date',
        options: {
          sort: false,
          setCellProps: () => ({ style: { width: '170px' } }),
          customBodyRender: value => (value ? moment(value).format(globals.dateFormats.short) : '-'),
        },
      },
    ],
    options: {
      filterType: 'dropdown',
      responsive: 'scrollFullHeight',
      selectableRows: 'none',
      rowsPerPageOptions: [10, 20, 50, 100],
      rowsPerPage: 20,
      print: false,
      download: false,
      viewColumns: false,
      onRowClick: rowData => {
        options.eventHandlers.toggleDrawer(true, rowData);
      },
      customToolbar: () => (
        <CustomToolbar eventHandlers={options.eventHandlers} isTableDataLoading={options.isUpdateTriggered} />
      ),
    },
  };
};

export default tableSettings;
